/**
 * Croatian plural agreement: 1 greška / 2 greške / 5 grešaka (with the
 * teens always taking the "many" form: 11 grešaka, 12 grešaka).
 */
export function pluralHr(
  n: number,
  one: string,
  few: string,
  many: string,
): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function countHr(n: number, one: string, few: string, many: string): string {
  return `${n} ${pluralHr(n, one, few, many)}`;
}
